import React, { useState } from 'react';
import './App.css';
import ContentLayout from './ContentLayout';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const subject = formData.name
      ? `Website message from ${formData.name}`
      : 'Website message';
    const body = [
      formData.name && `Name: ${formData.name}`,
      formData.email && `Email: ${formData.email}`,
      formData.message,
    ].filter(Boolean).join('\n\n');

    window.location.href = `mailto:john@johnmalam.co.uk?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };

  return (
    <ContentLayout
      title="Contact"
      intro="Send John a message about books, school visits, or family-history research."
      heroImage="/banners/contact.png"
      heroPosition="bottom center"
    >
      <form className="content-form" onSubmit={handleSubmit}>
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleInputChange}
          placeholder="Name"
          className="content-field"
        />
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleInputChange}
          placeholder="Email"
          className="content-field"
        />
        <textarea
          name="message"
          value={formData.message}
          onChange={handleInputChange}
          placeholder="Message"
          className="content-field"
        />
        <button type="submit" className="content-button">Send</button>
      </form>
    </ContentLayout>
  );
}

export default Contact;
